import { all, fork, call, put, select, takeLatest } from 'redux-saga/effects';
import api from '@api/api';
import { SHOW_MODAL } from '@store/actions/commonAction';
import { isFunction, isSuccessStatus } from '@common/utils';
import * as actions from '@store/actions/agentRoleAction';
import { fileDown } from '@common/utils/excelDown';

let modalMsg = '';

//사용자별 메뉴목록 조회
function* getAppAgentRoleMenu({ payload }) {
  const { status, data } = yield call(api.getAppAgentRoleMenu, {
    payload: {
      empno: payload.empno,
      aplctnTpCd: payload.aplctnTpCd,
      aplctnDvcTyCd: payload.aplctnDvcTyCd,
    },
  });

  if (status === 200) {
    yield put({
      type: 'GET_APP_AGENT_ROLE_MENU_SUCCESS',
      payload: data,
    });
  }
}

function* saveAppAgentRoleMenu({ payload }) {
  const { status, data } = yield call(api.saveAppAgentRoleMenu, {
    payload: payload,
  });

  if (status === 200) {
    modalMsg = '저장되었습니다.';

    yield put({
      type: SHOW_MODAL,
      payload: {
        visible: true,
        type: 'info',
        msg: modalMsg,
      },
    });
  } else {
    modalMsg = '저장실패했습니다.';

    yield put({
      type: SHOW_MODAL,
      payload: {
        visible: true,
        type: 'info',
        msg: modalMsg,
      },
    });
  }
}

function* getAgentRoles({ payload }) {
  const { status, data } = yield call(api.getAgentRoles, {
    payload: {
      empno: payload.empno,
      aplctnTpCd: payload.aplctnTpCd,
      aplctnDvcTyCd: payload.aplctnDvcTyCd,
    },
  });

  if (status === 200) {
    yield put({
      type: 'GET_AGENT_ROLES_SUCCESS',
      payload: data,
    });
  }
}

//사용자(설계사) 목록 조회
function* findAgentsCdpRolePagingList({ payload }) {
  console.log('payload', payload);

  const { status, data } = yield call(api.getRoleAgents, {
    payload: payload,
  });

  if (status === 200) {
    yield put({
      type: 'FIND_AGENTS_CDP_PAGING_LIST_SUCCESS',
      payload: data,
    });    

    if (data.RSLT_DATA.pagingResult.rows > 0) {
      yield put({
        type: actions.GET_APP_AGENT_ROLE_MENU,
        payload: {
          empno: data.RSLT_DATA.pagingResult.list[0].empno,
          aplctnTpCd: '01',
          aplctnDvcTyCd: '01',
        },
      });

      yield put({
        type: actions.GET_AGENT_ROLES,
        payload: {
          empno: data.RSLT_DATA.pagingResult.list[0].empno,
          aplctnTpCd: '01',
          aplctnDvcTyCd: '01',
        },
      });
    } else {
      yield put({
        type: actions.CLEAR_AGENT_ROLES_MENU_ALL,
      });
    }
  }
}

//사용자별권한관리 엑셀다운로드
function* roleAgentExcelDownload({ payload }) {
  const { status, data } = yield call(api.findAgentsCdpAllExcelDownload, {
    payload: {
      chnlCd:payload.chnlCd,
      hqSvcOrgCd:payload.hqSvcOrgCd,
      agncSvcOrgCd:payload.agncSvcOrgCd,
      aplctnDvcTyCd:payload.aplctnDvcTyCd,
      agentNm: payload.agentNm,
      empno: payload.empno
    },
  });

  if (status === 200) {
    fileDown(data, payload.excelFileName);
  }
}

function* getAgentsTakenRole({ payload }) {
  const { status, data } = yield call(api.getAgentsTakenRole, {
    payload: payload,
  });

  if (status === 200) {
    
    yield put({    
      type: 'GET_AGENTS_TAKEN_ROLE_SUCCESS',
      payload: data,
    });    

    
      yield put({
        type: actions.CLEAR_AGENT_ROLES_MENU_ALL,
      });      

  }

  if (payload.callback)
  payload.callback(status, payload, data);   

}

// 채널기준 본부조회
function* getHqListByChannel({ payload }) {
  const { status, data } = yield call(api.getHqListByChannel, {
    payload: {
      chnlCd: payload.chnlCd,
    },
  });

  if (status === 200) {
    yield put({
      type: actions.GET_HQ_LIST_BY_CHANNEL_SUCCESS,
      payload: data,
    });
  }
}

// 본부기준 지점조회
function* getAgencyListByHq({ payload }) {
  const { status, data } = yield call(api.getAgencyListByHq, {
    payload: {
      chnlCd: payload.chnlCd,
      hqCd: payload.hqCd,
      agncCd:payload.agncCd
    },
  });

  if (status === 200) {
    yield put({
      type: actions.GET_AGENCY_LIST_BY_HQ_SUCCESS,
      payload: data,
    });
  }
}

// watcher
function* watchAppList() {
  yield takeLatest(actions.GET_APP_AGENT_ROLE_MENU, getAppAgentRoleMenu);
  yield takeLatest(actions.GET_AGENT_ROLES, getAgentRoles);
  yield takeLatest(actions.SAVE_APP_AGENT_ROLE_MENU, saveAppAgentRoleMenu);
  yield takeLatest(actions.GET_AGENT_ROLES, getAgentRoles);
  yield takeLatest(actions.FIND_AGENTS_CDP_ROLE_PAGING_LIST,findAgentsCdpRolePagingList);
  yield takeLatest(actions.ROLE_AGENT_EXCEL_DOWNLOAD, roleAgentExcelDownload);
  yield takeLatest(actions.GET_AGENTS_TAKEN_ROLE, getAgentsTakenRole);
  //본부, 지점 검색
  yield takeLatest(actions.GET_HQ_LIST_BY_CHANNEL, getHqListByChannel);
  yield takeLatest(actions.GET_AGENCY_LIST_BY_HQ, getAgencyListByHq);
}

export default function* agentRoleSaga() {
  yield all([fork(watchAppList)]);
}
